import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { Icon } from "@iconify/react";

const TemplateFields = ({ fields, setFields }) => {
  const surveyFields = fields.filter((field) => field.role === "surveyor");

  const handleChange = (e) => {
    setFields(
      fields.map((item) => {
        const temp = { ...item };
        if (temp.id === e.id) {
          temp.isIncluded = !temp.isIncluded;
        }
        return temp;
      })
    );
  };
  return (
    <>
      <div className="fieldTitle">
        <i>
          <Icon icon="fluent:document-bullet-list-20-regular" />
        </i>
        <div className="media-body">Choose fields</div>
      </div>
      <Card>
        <Card.Body className="px-4">
          <Row>
            {surveyFields.map((field) => (
              <Col lg="4" key={field.id}>
                <div className="mb-3">
                  <input
                    type="checkbox"
                    disabled={field.isRequired}
                    checked={field.isRequired || field.isIncluded}
                    className="checkbox-style"
                    onChange={() => handleChange(field)}
                    id={field.id}
                    name="fields"
                  />
                  <label htmlFor={field.id}>
                    <span>{field.title}</span>
                  </label>
                </div>
              </Col>
            ))}
            {/* <Col lg="4" >
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-1' name='fields' />
                                <label htmlFor="labelfield-1"><span>Plan</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-2' name='fields' />
                                <label htmlFor="labelfield-2"><span>Internal Inspection</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-3' name='fields' />
                                <label htmlFor="labelfield-3"><span>Developed Site Area</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-4' name='fields' />
                                <label htmlFor="labelfield-4"><span>Undeveloped Site Area</span></label>
                            </div>
                        </Col> */}

            {/* <Col lg="4" >
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-5' name='fields' />
                                <label htmlFor="labelfield-5"><span>No. of parking spaces/
                                    pitches/bed spaces</span></label>
                            </div>

                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-6' name='fields' />
                                <label htmlFor="labelfield-6"><span>Tenure</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-7' name='fields' />
                                <label htmlFor="labelfield-7"><span>Locality</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-8' name='fields' />
                                <label htmlFor="labelfield-8"><span>Current Use</span></label>
                            </div>


                        </Col> */}

            {/* <Col lg="4">
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-9' name='fields' />
                                <label htmlFor="labelfield-9"><span>Description</span></label>

                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-10' name='fields' />
                                <label htmlFor="labelfield-10"><span>Age of Build</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-11' name='fields' />
                                <label htmlFor="labelfield-11"><span>Condition</span></label>
                            </div>
                            <div className='mb-3'>
                                <input type="checkbox" className="checkbox-style" id='labelfield-12' name='fields' />
                                <label htmlFor="labelfield-12"><span>NIA/GIA/GEA</span></label>
                            </div>
                        </Col> */}
          </Row>
        </Card.Body>
      </Card>
    </>
  );
};

export default TemplateFields;
